import React from 'react'; // Fragment
import './StockQuantity.css';
import { useTranslation } from 'react-i18next';
const StockQuantity = ({
  accountingStock,
  physicalStock,
  oppeningStock,
  OpeningStockValue,
  reorder,
  symbol,
  inventory_type,
  inventoryAccount,
}) => {
  const { t } = useTranslation();
  return (
    <div className="stock_row stock_mob-row">
      <div className="float-left w-33 pr-10">
        <div className="stock_row_inner float-left w-100 background_custom p-10 height_custom">
          <span className="upper_text">{t('Items.accounting_stock')}</span>
          <hr />
          <div>
            <div className="stockfields">
              <span>{t('Items.stock_on_hand')}</span>
              <span>
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? accountingStock.stock_on_hand
                  : '-'}
              </span>
            </div>
            <hr />
            <div className="stockfields">
              <span>{t('Items.committed_stock')}</span>
              <span>
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? accountingStock.committed_stock
                  : '-'}
              </span>
            </div>
            <hr />
            <div className="stockfields">
              <span>{t('Items.available_for_sale')}</span>
              <span>
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? accountingStock.available_sale_stock
                  : '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="float-left w-33 pr-10 ">
        <div className="stock_row_inner float-left w-100 background_custom p-10 height_custom">
          <span className="upper_text">{t('Items.physical_stock')}</span>
          <hr />
          <div>
            <div className="stockfields">
              <span>{t('Items.stock_on_hand')}</span>
              <span>
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? physicalStock.stock_on_hand
                  : '-'}
              </span>
            </div>
            <hr />
            <div className="stockfields">
              <span>{t('Items.committed_stock')}</span>
              <span>
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? physicalStock.committed_stock
                  : '-'}
              </span>
            </div>
            <hr />
            <div className="stockfields">
              <span>{t('Items.available_for_sale')}</span>
              <span>
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? physicalStock.available_sale_stock
                  : '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="float-left w-33 pr-10">
        <div className="stock_row_inner float-left w-100 background_custom p-10 height_custom">
          <div className="stock_information">
            <div className="float-left w-100">
              <span className="float-left">{t('Items.inventory_account')}</span>
              <span className="float-right">
                {inventory_type && inventory_type === 'inventory'
                  ? inventoryAccount?.title === 'Inventory Asset'
                    ? t('Items.inventory_asset')
                    : inventoryAccount?.title
                  : '-'}
              </span>
            </div>
            <div className="float-left w-100">
              <span className="float-left">{t('Items.opening_stock')}</span>
              <span className="float-right">
                {inventory_type && inventory_type === 'inventory'
                  ? oppeningStock
                  : '-'}
              </span>
            </div>
            <div className="float-left w-100 d-flex space-between">
              <span className="float-left">
                {t('Items.opening_stock_valuee')}
              </span>
              <span
                className="float-right"
                style={{
                  width: '40%',
                  textAlign: 'right',
                  wordBreak: 'break-word',
                }}
              >
                {' '}
                {/* {`${symbol}`} */}
                {inventory_type && inventory_type === 'inventory'
                  ? `${symbol}${OpeningStockValue.toFixed(2)}`
                  : '-'}
              </span>
            </div>
            <div className="float-left w-100">
              <span className="float-left">{t('Items.reorder_value')}</span>
              <span className="float-right">
                {' '}
                {inventory_type && inventory_type === 'inventory'
                  ? reorder
                  : '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockQuantity;
